/**
 * Archivo: MetaTags.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este componente define las etiquetas meta y los enlaces a hojas de estilo para la aplicación.
 * 
 * Dependencias:
 * - react: ^18.2.0
 * - bootstrap: ^4.0.0
 * - estilos.css: Hoja de estilos personalizada para la aplicación.
 * 
 * Propósito:
 * Proporcionar las etiquetas meta esenciales y enlaces a hojas de estilo para la aplicación.
 */

import React from 'react';

const MetaTags = () => {
    return (
        <>
            <meta charSet="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>App Cerbuna</title>
            <link rel="stylesheet" href="estilos.css" />
            {/* Bootstrap CSS */}
            <link
                crossOrigin="anonymous"
                href="https://cdn.jsdelivr.net/npm/bootstrap@4.0.0/dist/css/bootstrap.min.css"
                integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm"
                rel="stylesheet"
            />
        </>
    );
};

export default MetaTags;
